import VeeValidate from 'vee-validate';
import {parse, isAfter, addDays} from 'date-fns';

VeeValidate.Validator.extend('char_name', (value) => value.search(/^[a-zA-Z0-9\-_\.]+$/) >= 0);

VeeValidate.Validator.extend('repeat_password', (value, [other]) => value === other, {
    hasTarget: true
});

VeeValidate.Validator.extend('date_order', (value, [other]) => {

    let startAt = parse(other, 'yyyy-MM-dd', new Date());
    let endAt = parse(value, 'yyyy-MM-dd', new Date());

    startAt = addDays(startAt, -1);

    return isAfter(endAt, startAt);
}, {
    hasTarget: true
});

VeeValidate.Validator.extend('datetime_order', ({start, end}) => {

    if (!start || !end) return true;

    return isAfter(end, start);
});

VeeValidate.Validator.extend('datetime_both', ({start, end}) => {

    if (!!start || !!end) {
        if (!start) return false;
        if (!end) return false;
    }

    return true;
});

VeeValidate.Validator.extend('uniq_currency_id', (value, [otherItems]) => {

    let items = [];

    try {
        items = JSON.parse(otherItems);
    } catch (e) {
        return true;
    }

    let foundItems = [];

    for (let key in items) {

        let item = items[key];

        if (foundItems.indexOf(item.currency_id) > -1 && value === item.currency_id) {
            return false;
        }

        foundItems.push(item.currency_id);
    }

    return true;
}, {
    hasTarget: true
});

export default VeeValidate;